import React from "react";
import { SkillStatusMenu } from "../../utils";
import text from "../../../locale.en.json";

export const TableColumnsAssignSkills = ({
  skillType = "persona", 
  isNavigatedFromRoleMatch = false, 
  isIndustryRoleTable = false,
  isGenAiDisprzAtomicSkillSource = false ,
  listOfSchemeId = []
}) => {
  const baseColumns = [
    {
      colKey: "checkbox",
      colValue: "checkbox",
      width: 60,
    },
    {
      colKey: "skillName",
      colValue: text.skill.skillName,
      width: 400
    },
    {
      colKey: "skillFamily",
      colValue: text.skill.skillFamily,
      colType: "column_render",
      width: 300,
      RenderColumn: (data) => <>{data?.skillFamily?.skillFamily}</>,
    },
    {
      colKey: "skillCategory",
      colValue: text.skill.skillCategory,
      colType: "column_render",
      width: 300,
      RenderColumn: (data) => <>{data?.skillCategory?.skillCategory}</>,
    },
    {
      colKey: "source",
      colValue: text.common.source,
      colType: "column_render",
      width: 300,
      RenderColumn: (data) => <>{data?.skillSource?.source}</>,
    },
    {
      colKey: "skillStatus",
      colValue: text.common.status,
      colType: "column_render",
      width: 300,
      RenderColumn: (data) => (
        <>
          {SkillStatusMenu?.find((el) => el.value === data?.skillStatus)?.label || ""}
        </>
      ),
    }
  ];

  const industryColumn = isIndustryRoleTable && {
    colKey: "industryProficiencyLevel",
    colValue: text.common.industryProficiency,
    colType: "column_render",
    width: 425,
    RenderColumn: (data) => <>{data?.industryProficiencyLevel?.level}</>,
  };

  const genAiColumns = isGenAiDisprzAtomicSkillSource
    ? listOfSchemeId?.map((count) => ({
        colKey: `target_proficiency${count}`,
        colMessage: isIndustryRoleTable ? `${text.common.setIndustryProficiency} ${count}PL` : "",
        colValue:
          skillType === "persona" || isNavigatedFromRoleMatch
            ? text.common.targetProficiency
            : `${text.common.setIndustryProficiency} ${count}PL`,
        editable: true,
        colType: "levelSelect",
        infoText:
            skillType === "persona" || isNavigatedFromRoleMatch
              ? text.persona.recommendedTargetProficiencyMessage
              : null,
        width: 300,
        proficiencySchemeLevelCount: count
      }))
    : [
        {
          colKey: "target_proficiency",
          colMessage: isIndustryRoleTable ? text.common.defaultToIndustryProficiency : "",
          colValue:
            skillType === "persona" || isNavigatedFromRoleMatch
              ? text.common.targetProficiency
              : text.common.defaultToIndustryProficiency,
          editable: true,
          colType: "levelSelect",
          infoText:
            skillType === "persona" || isNavigatedFromRoleMatch
              ? text.persona.recommendedTargetProficiencyMessage
              : text.role.industryFrameworkProficiencyColumnDescription,
          width: 300,
        }
      ];

  return [
    ...baseColumns,
    ...(industryColumn ? [industryColumn] : []),
    ...genAiColumns
  ];
};
